import BaseMap from '../../BaseMap.jsx'
import usePluginSwap from '../../plugins/usePluginSwap.jsx'
import hotkeys from './hotkeys.mjs'
import ToolBar from './ToolBar.jsx'
import useReadMap from './useReadMap.mjs'
import useMindMapPlugins from './useMindMapPlugins.mjs'
import usePermission from './usePermission.mjs'

const components = {ToolBar}

export default function NavigatorMap({id, permission, ...props}) {
    const readMap = useReadMap(id)

    const plugins = [
        useMindMapPlugins(),
        // TODO
        usePermission(permission),
        usePluginSwap(),
    ]

    return (
        <BaseMap
            components={components}
            hotkeys={hotkeys}
            plugins={plugins}
            readMap={readMap}
            {...props}
        />
    )
}
